import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import LinearProgress from '@material-ui/core/LinearProgress';
import SearchBar from 'tuc-webui-base/components/SearchBar';
import StorageObjectListItem from '../batches/StorageObjectListItem';

import './SelectStorageObjectDialog.scss';

class SelectStorageObjectDialog extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    configuration: PropTypes.shape({}),
    viewService: PropTypes.shape({}).isRequired,
    repositoryService: PropTypes.shape({
      fetchSharedObjects: PropTypes.func.isRequired,
    }).isRequired,
    open: PropTypes.bool.isRequired,
    filterStorageObject: PropTypes.func,
  };

  static defaultProps = {
    configuration: undefined,
    filterStorageObject: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      title: 'Select storage object to add',
      loading: true,
      ...this.getInitialStateValues(),
    };

    // Bindings
    this.handleContextChange = this.handleContextChange.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.loadStorageObjects();
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      // Update the default values and validation errors each time the dialog is showing
      // Example for using this method for this use case can be found here:
      // https://reactjs.org/docs/react-component.html#componentdidupdate
      this.loadStorageObjects();
    }
  }

  loadStorageObjects() {
    const { repositoryService, filterStorageObject } = this.props;
    const { context } = this.state;
    return repositoryService.fetchSharedObjects().then((objects) => {
      const filteredStorageObjects = !filterStorageObject
          ? objects : objects.filter(o => filterStorageObject(o));
      this.setState({
        loading: false,
        storageObjects: filteredStorageObjects,
        ...this.filterObjectsAndSelect(filteredStorageObjects, context),
      });
    });
  }

  getInitialStateValues() {
    return { storageObjects: [], selectedObjectId: undefined, context: { search: '' } };
  }

  filterObjectsAndSelect(objects, context = {}) {
    const { selectedObjectId } = this.state;
    const { search } = context;
    const matchContext = (s) => {
      if (!search) return true;
      const b = s && (s.indexOf(search) >= 0);
      return b;
    };
    const objectMatchContext = (o) => {
      return !search || matchContext(o.container ? `${o.container}/${o.name}` : o.name);
    };
    const filteredObjects = objects.filter(objectMatchContext);
    const selectedObject = selectedObjectId && filteredObjects.find(object => object.id === selectedObjectId);
    return {
      filteredObjects,
      selectedObjectId: selectedObject ? selectedObject.id : (filteredObjects.length && filteredObjects[0].id || null),
    };
  }

  handleCancel = () => {
    this.setState(this.getInitialStateValues());
    this.props.onClose(null);
  };

  handleOk = () => {
    const { selectedObjectId } = this.state;
    this.setState(this.getInitialStateValues());
    this.props.onClose(this.state.storageObjects.find(o => o.id === selectedObjectId));
  };

  handleContextChange(context) {
    const { storageObjects } = this.state;
    this.setState({
      context,
      ...this.filterObjectsAndSelect(storageObjects, context),
    });
  }

  handleObjectSelected = (object) => {
    this.setState({ selectedObjectId: object.id });
  };

  setInitialState() {
    this.setState(this.getInitialStateValues());
  }

  render() {
    const { open } = this.props;
    const { title, loading, selectedObjectId, context, filteredObjects } = this.state;
    return (
      <Dialog
        disableBackdropClick
        aria-labelledby="grbrsm-select-storageobject-title"
        className="grb-create-dialog"
        onClose={this.handleCancel}
        open={open}
      >
        <DialogTitle id="grbrsm-select-storageobject-title">{title}</DialogTitle>
        <DialogContent>
          <div className="grbrsm-select-storageobject-content">
            {loading ? (
              <div className="tuc-loading-panel">
                <Typography variant="h4">Loading storage objects</Typography>
                <LinearProgress style={{ width: '100%' }} />
              </div>
            ) : (
              <div className="grbrsm-select-storageobject-body">
                <header className="grb-tablepanel-toolbar">
                  <SearchBar
                    {...this.props}
                    context={context}
                    onContextChange={this.handleContextChange}
                    placeholder="Search storage objects..."
                  />
                </header>
                <List component="nav" aria-label="storage object list" dense>
                  {filteredObjects.map(object => (
                    <StorageObjectListItem
                      {...this.props}
                      key={object.id}
                      object={object}
                      onSelect={this.handleObjectSelected}
                      selected={object.id === selectedObjectId}
                    />
                  ))}
                </List>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} color="primary" disabled={!selectedObjectId}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default SelectStorageObjectDialog;
